export const NUMERIC_LOCALE_ZHCHT = {
    placeholder: 'è«è¼¸å¥æ¸å­',
    range: {
        begin: 'è«è¼¸å¥éå§æ¸å­',
        end: 'è«è¼¸å¥çµææ¸å­'
    }
};
